import Paper from "@mui/material/Paper";
import React, { useContext } from "react";
import { ResponsivePie } from "@nivo/pie";
import { Typography } from "@mui/material";
import { dashboardContext } from "../../Dashboard";

const MARGIN = { top: 15, bottom: 15 };

const STYLES = {
  root: {
    textAlign: "center",
    position: "relative",
    height: 250,
  },
};

const PIE_THEME = {
  axis: {
    fontSize: "12px",
    tickColor: "#eee",
    ticks: {
      line: {
        stroke: "#555555",
      },
    },
  },
};

export default function PersonDistribution() {
  const { topSummaryList = [] } = useContext(dashboardContext);

  return (
    <Paper
      sx={{
        flexDirection: "column",
        height: "100%",
        width: "480px",
      }}
      elevation={0}
    >
      <Typography sx={{ fontSize: "16px", fontWeight: "bold", pb: "20px" }}>
        募集全体に対するスキルマッチ率毎の技術提供主(要員)数分布
      </Typography>

      <div style={STYLES.root}>
        <ResponsivePie
          colors={{ datum: "data.color" }}
          margin={MARGIN}
          data={topSummaryList}
          enableArcLinkLabels={true}
          arcLinkLabelsDiagonalLength={10}
          arcLinkLabelsStraightLength={5}
          arcLinkLabelsTextOffset={12}
          arcLabelsSkipAngle={10}
          valueFormat={(num) => `${typeof num === "number" ? num.toLocaleString() : num}人`}
          theme={PIE_THEME.axis}
          labelTextColor={{ from: "color", modifiers: [["darker", 1.2]] }}
          arcLinkLabelsSkipAngle={10}
        />
      </div>
    </Paper>
  );
}